export default __webpack_public_path__ + "static/media/chevron-left.27b60f42.svg";